(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', '@material-ui/core/styles', '@material-ui/core/IconButton', '../../elements', './Tooltip', '../../elements/typography', '../../styles'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('@material-ui/core/styles'), require('@material-ui/core/IconButton'), require('../../elements'), require('./Tooltip'), require('../../elements/typography'), require('../../styles'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.styles, global.IconButton, global.elements, global.Tooltip, global.typography, global.styles);
    global.InfoTooltip = mod.exports;
  }
})(this, function (exports, _react, _styles, _IconButton, _elements, _Tooltip, _typography, _styles2) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var React = _interopRequireWildcard(_react);

  var _IconButton2 = _interopRequireDefault(_IconButton);

  var _Tooltip2 = _interopRequireDefault(_Tooltip);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  var InfoTooltip = function InfoTooltip(_ref) {
    var content = _ref.content,
        placement = _ref.placement,
        classes = _ref.classes,
        testId = _ref['data-testid'];
    return React.createElement(
      _Tooltip2.default,
      {
        placement: placement,
        content: React.createElement(
          _typography.Note,
          { light: true },
          content
        ),
        disableHoverListener: true,
        'data-testid': testId
      },
      React.createElement(
        _IconButton2.default,
        {
          'aria-label': 'More Information',
          classes: { colorInherit: classes.overrides, root: classes.root }
        },
        React.createElement(_elements.MaterialIcon, { name: 'help_outline' })
      )
    );
  };


  InfoTooltip.defaultProps = {
    placement: 'top'
  };

  var styles = {
    // MaterialIcon is defaulted to 1rem, so we are defaulting IconButton size to 2rem to maintain ratio
    // Tech-Debt: Create reusable IconButton component.
    root: {
      width: '2rem',
      height: '2rem'
    },
    overrides: {
      color: _styles2.colors.prussian
    }
  };

  exports.default = (0, _styles.withStyles)(styles)(InfoTooltip);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Tooltip/InfoTooltip.js
// module id = 1229
// module chunks = 0